import React, { createRef, useState, useMemo } from "react"
import algoliasearch from "algoliasearch/lite"
import { InstantSearch } from "react-instantsearch-dom"
// import algoliasearchHelper from 'algoliasearch-helper';
import SearchBox from "./search-box"
import SearchResult from "./search-results"
import HitsDialog from "./hits-dialog"
// import useClickOutside from "./use-click-outside"

import "./_style.scss"

// Language
import { useTranslation } from "react-i18next"

export default function Search({ indices }) {
  const rootRef = createRef()
  const [query, setQuery] = useState()
  const [hasFocus, setFocus] = useState(false)
  const searchClient = useMemo(
    () =>
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
      ),
    []
  )

  // const searchHelper = algoliasearchHelper(searchClient, indices[0].name, {
  //   customRanking: ['asc(badge = "eop")']
  // });
  // console.log('searchHelper', searchHelper);

  var searchStatus = query && query.length > 0 && hasFocus ? "active" : "d-none"
  var textStatus =
    query && query.length > 0 && hasFocus ? "d-none" : "searchtip"

  const { t } = useTranslation()

  // useClickOutside(rootRef, () => setFocus(false))

  return (
    <div id="searchbar" className="StyledSearchRoot active" ref={rootRef}>
      <div className="search-container container-max">
        <div className="position-relative">
          <div className="search-content">
            <span className={textStatus + " mb-3"}>
              {t("Cosa stai cercando?")}
            </span>
            <InstantSearch
              searchClient={searchClient}
              indexName={indices[0].name}
              onSearchStateChange={({ query }) => setQuery(query)}
              // customRanking={[
              //   'asc(badge = "eop")'
              // ]}
            >
              {query && query.length > 0 && <HitsDialog indices={indices} />}
              <SearchBox
                className="searchbox"
                placeholder={t("Cerca")}
                onFocus={() => setFocus(true)}
                hasFocus={hasFocus}
              />
              <SearchResult
                id="searchresult"
                className={searchStatus}
                show={query && query.length > 0 && hasFocus}
                indices={indices}
              />
            </InstantSearch>
          </div>
        </div>
      </div>
    </div>
  )
}
